<template>
  <div class="px-3 py-3 mb-5 col-24 col-md-11">
    <Onboarding ref="refOnboarding" />
    <PasswordConfirmationActivationModal
      v-if="actionType"
      @updateEmailAuthentication="changeDados"
      :two-factory-authentication="twoFactoryAuthentication"
      :actionType="actionType"
    />
    <div class="col d-column">
      <h1 class="title pt-2 mb-0" v-text="$ml.get('authentication')">
        Autenticação
      </h1>
      <h1 class="title">
        <span class="pb-2" v-text="$ml.get('makeYourAccessEvenMoreSecure')"
          >Torne seu acesso ainda mais seguros</span
        >
      </h1>

      <div class="card mb-3" id="phoneValidation">
        <div class="card-header">
          <h6 class="m-0 p-0 light" v-text="$ml.get('accountRecovery')">
            Recuperação de conta
          </h6>
        </div>

        <div class="card-body">
          <tr
            v-if="loading"
            class="loading row justify-self-center d-flex align-items-center"
          >
            <div class="c-loader m-0"></div>
          </tr>
          <tbody v-if="!loading" class="row">
            <tr class="row w-100">
              <td class="col-10">
                <strong v-text="$ml.get('phoneValidation')"
                  >Validação de telefone</strong
                >
              </td>
              <td class="col-10 pl-0 text-muted text-capitalize">
                <font v-if="phone_hash && phoneValidate"
                  >*****-{{ phone_hash }}</font
                >
              </td>
              <td class="col-4 pl-0">
                <div class="row justify-content-end">
                  <label v-if="getUserType === 'company' && !showInputSms" class="switch mb-0">
                    <input
                      type="checkbox"
                      @click.prevent="savePhone()"
                      :checked="phoneValidate"
                    />
                    <span class="slider round"></span>
                  </label>
                  <label v-else class="switch mb-0">
                    <input
                      :disabled="showInputSms"
                      type="checkbox"
                      @click.prevent="savePhone()"
                      :checked="phoneValidate"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
              </td>
            </tr>
          </tbody>
          <hr v-if="showInputSms || showInputPhone" />

          <!-- input for telephone -->
          <div v-show="showInputPhone">
            <transition name="fade">
              <div class="row">
                <div class="col-18 vue-phone-number-input">
                  <label class="text-muted" v-text="$ml.get('phoneNumber')"
                    >Número de telefone</label
                  >
                  <div class="form-group">
                    <vue-phone-number-input
                      v-model="desc"
                      placeholder="(99) 99999-9999"
                      :default-country-code="'BR'"
                      :translations="translations"
                      @update="updatePhoneNumber"
                    />
                    <label
                      v-if="msgPhoneInvalid"
                      class="lblError"
                      v-text="$ml.get('thePhoneIsNotValid')"
                      >O telefone não é valido.</label
                    >
                  </div>
                </div>
              </div>
            </transition>
            <div class="mb-2">
              <RecaptchaV2
                ref="recaptcha"
                @verify="setRecaptchaToken"
                @expired="tokenRecaptcha = ''"
              />
            </div>
            <button
              :disabled="loadingBtn || !tokenRecaptcha"
              @click="executeRecaptcha('sendSms')"
              class="btn"
              v-text="$ml.get('save')"
            >
              Salvar
            </button>
          </div>

          <!-- Input for code sms -->
          <div v-show="showInputSms">
            <div class="row">
              <transition name="fade">
                <div class="col-8">
                  <label class="text-muted" v-text="$ml.get('smsCode')"
                    >Código SMS</label
                  >
                  <div class="form-group">
                    <the-mask
                      style="width: 302px"
                      class="form-control"
                      v-model="codeSms"
                      :mask="['######']"
                      placeholder="999999"
                    />
                    <label
                      v-if="!errorAwaitNewRequest"
                      style="color: #730ba9; cursor: pointer; font-size: 12px; white-space: nowrap;"
                      @click="sendCodeSms('phone')"
                      >{{
                        timeLeftSms > 0
                          ? `${$ml.get(
                              "requestNewCodeEmail",
                            )} ${formattedTimeSMS}`
                          : $ml.get("receiveCode")
                      }}</label
                    >
                    <label v-else class="lblError" v-text="$ml.get('awaitNewToken')">Aguarde! Em breve, você poderá solicitar um novo token.</label>
                    <label
                      v-if="validError && !$v.codeSms.required"
                      class="lblError"
                      v-text="$ml.get('enterTheCodeReceivedBySms')"
                      >Informe o código recebido por sms</label
                    >
                    <label
                      v-if="validError && !$v.codeSms.minLength"
                      class="lblError"
                      v-text="$ml.get('enterTheCodeReceivedBySms')"
                      >Informe o código recebido por sms</label
                    >
                  </div>
                  <div class="mb-3">
                    <RecaptchaV2
                      ref="recaptchaPhone"
                      @verify="setRecaptchaToken"
                      @expired="tokenRecaptcha = ''"
                    />
                  </div>
                </div>
              </transition>
            </div>
            <div class="row mt-1">
              <div class="col">
                <div class="form-group">
                  <button
                    @click="executeRecaptcha('activePhone')"
                    :disabled="loadingBtn || !codeSms || !tokenRecaptcha"
                    class="btn"
                  >
                    <Spinner v-show="loadingBtn" class="px-5" />
                    <font v-show="!loadingBtn" v-text="$ml.get('validatePhone')"
                      >Validar telefone</font
                    >
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-3" id="authentication2fa" v-if="!ssoIsActive || getUserType != 'company' || userBugHunt">
        <div class="card-header">
          <h6 class="m-0 p-0 light" v-text="$ml.get('authentication')">
            Autenticação
          </h6>
        </div>

        <div class="card-body">
          <tr
            v-if="loading || loading2fa"
            class="loading row justify-self-center d-flex align-items-center"
          >
            <div class="c-loader m-0"></div>
          </tr>
          <tbody v-if="!loading && !loading2fa" class="row">
            <tr class="row w-100">
              <td class="col-10"><strong>Two-factor authentication</strong></td>
              <td class="col-10 pl-0 text-muted text-capitalize"></td>

              <td class="col-4 pl-0">
                <div class="row justify-content-end">
                  <label v-if="getUserType === 'company'" class="switch mb-0">
                    <input
                      type="checkbox"
                      @click.prevent="executeRecaptcha('show2fa')"
                      :checked="authentication2Fa"
                    />
                    <span class="slider round"></span>
                  </label>
                  <label v-else class="switch mb-0">
                    <input
                      type="checkbox"
                      @click.prevent="executeRecaptcha('show2fa')"
                      :checked="authentication2Fa"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
              </td>
            </tr>
          </tbody>
          <transition v-if="!authentication2Fa && !loading2fa" name="fade">
            <div class="row" v-show="showQrcode">
              <div class="col-24">
                <hr />
                <h6 v-text="$ml.get('enableTwoFactorAuthentication')">
                  Habilitar autenticação de dois fatores
                </h6>
                <label
                  ><font v-text="$ml.get('makeSureYouHaveACompatibleAppLike')"
                    >Certifique-se de ter um aplicativo compatível como</font
                  >
                  <a
                    target="new_blank"
                    rel="noopener noreferrer"
                    href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=pt_BR&gl=US"
                    >Google Authenticator </a
                  ><font class="mr-1" v-text="$ml.get('or')">ou</font>
                  <a
                    target="new_blank"
                    rel="noopener noreferrer"
                    href="https://duo.com/product/multi-factor-authentication-mfa/duo-mobile-app"
                    >Duo Mobile</a
                  >. <br /><font v-text="$ml.get('openYourApp')"
                    >Abra seu aplicativo.</font
                  >
                  <br /><font v-text="$ml.get('selectAddAccount')"
                    >Selecione "Adicionar conta" ou "+" e digitalize o código QR
                    abaixo</font
                  >
                </label>
              </div>

              <div
                class="border border-top-0 border-left-0 border-bottom-0 border-1 pr-4"
              >
                <p>
                  <img
                    id="image"
                    :src="qrCode"
                    class="img-thumbnail"
                    alt="QRCode Authentication"
                    width="150"
                  />
                </p>
              </div>

              <div class="col-12 ml-4">
                <div class="form-group col-24">
                  <label class="text-muted" v-text="$ml.get('useCodeSms')"
                    >Use o código recebido por SMS</label
                  >
                  <the-mask
                    class="form-control col"
                    v-model="codeSms"
                    :mask="['### ###']"
                    :placeholder="$ml.get('enterTheCode')"
                  />
                  <div
                    class="col-12"
                    :style="[
                      { display: errorCodeEmail ? 'flex' : '' },
                      {
                        'justify-content': errorCodeEmail
                          ? 'space-between'
                          : '',
                      },
                    ]"
                  >
                    <transition name="fade">
                      <label
                        v-if="errorCodeEmail"
                        style="position: relative; !important"
                        class="lblError"
                        v-text="$ml.get('invalidCodeError')"
                      >
                        O código informado não é válido!
                      </label>
                    </transition>
                    <label
                     v-if="!errorAwaitNewRequest"
                      style="color: #730ba9; cursor: pointer; font-size: 12px; white-space: nowrap;"
                      @click="sendCodeSms('2fa')"
                      >{{
                        timeLeftSms > 0
                          ? `${$ml.get(
                              "requestNewCodeEmail",
                            )} ${formattedTimeSMS}`
                          : $ml.get("receiveCode")
                      }}</label
                    >
                    <label v-else-if="errorAwaitNewRequest && !errorCodeEmail" class="lblError" v-text="$ml.get('awaitNewToken')">Aguarde! Em breve, você poderá solicitar um novo token.</label>
                  </div>
                </div>
                <label class="text-muted mb-3">
                  <font class="mr-1" v-text="$ml.get('code')">Código</font>
                  <font class="text-blue">G</font>
                  <font class="text-danger">o</font>
                  <font class="text-warning">o</font>
                  <font class="text-blue">g</font>
                  <font class="text-success">l</font>
                  <font class="text-danger">e</font>
                  Authenticator</label
                >
                <div class="row">
                  <transition name="fade">
                    <div class="form-group col-24">
                      <the-mask
                        class="form-control col"
                        v-model="code2fa"
                        :mask="['### ###']"
                        placeholder="999 999"
                      />
                      <label
                        v-if="validError && !$v.code2fa.required"
                        class="lblError"
                        v-text="$ml.get('enterTheCode')"
                        >Digite o código</label
                      >
                      <label
                        v-if="validError && !$v.code2fa.minLength"
                        class="lblError"
                        v-text="$ml.get('enterTheCode')"
                        >Digite o código</label
                      >
                    </div>
                  </transition>
                </div>
                <div class="mb-3">
                  <RecaptchaV2
                    ref="recaptchaV2"
                    @verify="setRecaptchaToken"
                    @expired="tokenRecaptcha = ''"
                  />
                </div>

                <div class="row mt-2">
                  <div class="col">
                    <div class="form-group">
                      <button
                        @click="executeRecaptcha('active2fa')"
                        :disabled="!tokenRecaptcha"
                        class="btn"
                        v-text="$ml.get('activate')"
                      >
                        Ativar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>

          <transition v-else name="fade">
            <div class="row" v-if="showQrcode && !loading2fa">
              <div class="col-24">
                <hr />
                <h6 v-text="$ml.get('storeYourBackupCodes')">
                  Armazene seus códigos de backup
                </h6>
                <label v-text="$ml.get('youCanUseOneOfTheseBackupCodes')">
                  Você pode usar um desses códigos de backup para fazer o login,
                  caso perca o acesso ao seu smartphone. Lembre-se de que cada
                  código só pode ser usado uma vez.
                </label>
                <label v-if="!codesRecovery.length"
                  ><font v-text="$ml.get('dashMsgYouHave')">Você possui</font>
                  <font class="text-danger"> {{ recovery_keys }} </font>
                  <font v-text="$ml.get('backupCodesLeft')"
                    >códigos de backup restantes</font
                  ></label
                >
              </div>

              <div class="col-24">
                <div class="row">
                  <div
                    v-for="(item, index) in codesRecovery"
                    :key="index"
                    class="form-group col-7 mr-2"
                  >
                    <input
                      class="form-control"
                      disabled
                      type="text"
                      :value="item"
                    />
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="form-group">
                    <button class="btn" @click="generateKeys()">
                      <Spinner v-show="loadingBtn" />
                      <font
                        v-show="!loadingBtn"
                        v-text="$ml.get('generateNewCodes')"
                      >
                        Gerar novos códigos</font
                      >
                    </button>
                    <button
                      @click="downloadCSVData()"
                      v-if="codesRecovery.length"
                      class="btn ml-2"
                      :disabled="loadingBtn"
                    >
                      <img
                        src="../../../src/assets/icons/download-white.svg"
                        width="16"
                        height="16"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>

      <div
        v-if="getUserType === 'hacker'"
        class="card mb-3 col-24"
        id="authenticationByEmail"
      >
        <div class="card-header">
          <h6 class="m-0 p-0 light" v-text="$ml.get('authenticationByEmail')">
            Autenticação por email
          </h6>
        </div>
        <div class="card-body p-0 px-3 mt-3 form-group col-24">
          <div class="col-24 d-flex justify-content-between align-items-center">
            <div class="d-flex" style="gap: 10px">
              <label
                style="font-weight: 500; font-size: 16px"
                class="m-0"
                v-text="$ml.get('authenticationViaEmail')"
                >Two-Factor Authentication (2FA) via Email</label
              >
              <VueCustomTooltip
                :label="$ml.get('emailAuthenticationInformation')"
                :multiline="true" size="is-large"
              >
                <svg width="16" height="16" class="mb-1">
                  <image
                    xlink:href="../../../src/assets/svg/info-fill.svg"
                    width="16"
                    height="16"
                  />
                </svg>
              </VueCustomTooltip>
            </div>
            <label class="switch mb-0 mr-2">
              <input
                type="checkbox"
                :checked="emailCodeRequired"
                @click.prevent="featureActivationAction('codeEmail')"
                v-b-modal.modal-email-authentication
              />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <DisableAuthModal
      v-model="showDisableAuthModal"
      @update:setRecaptchaToken="setRecaptchaToken"
      @update:codeInput="updateCodeInput"
      @update:codeEmail="updateCodeEmail"
      @disableAuth="disableAuth"
      :modal-data="modalData"
      ref="disableAuthModal"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { minLength, required } from "vuelidate/lib/validators";
import Onboarding from "../../components/Onboarding.vue";
import RecaptchaV2 from "../../components/recaptchaV2.vue";
import {
  default as AccountService,
  default as accountService,
} from "../../services/account.service";
import PasswordConfirmationActivationModal from "../modais/PasswordConfirmationActivationModal.vue";
import DisableAuthModal from "./DisableAuthModal.vue";
export default {
  components: {
    RecaptchaV2,
    DisableAuthModal,
    PasswordConfirmationActivationModal,
    Onboarding,
  },
  data() {
    return {
      telephoneActive: true,
      desc: "",
      phone: {
        countryCode: "",
        number: "",
        isValid: false,
      },
      msgPhoneInvalid: "",
      codeSms: "",
      code2fa: "",
      phone_hash: "",
      phoneValidate: false,
      authentication2Fa: false,
      showInputPhone: false,
      showInputSms: false,
      showQrcode: false,

      validError: false,
      submitStatus: false,

      loading: true,
      loadingBtn: false,
      loading2fa: false,

      qrCode: null,

      codesRecovery: [],
      recovery_keys: 5,

      function: "changeDados",

      tokenRecaptcha: "",
      showDisableAuthModal: false,
      disable2faCode: "",
      modalData: {
        title: "",
        description: "",
        type: "",
      },

      actionType: "",
      twoFactoryAuthentication: false,
      getUserType: "",
      emailCodeRequired: false,
      codeEmail: "",
      timeLeftSms: "",
      formattedTimeSMS: 0,
      errorCodeEmail: false,
      translations: {
        countrySelectorLabel: this.$ml.get("countrySelectorLabel"),
        phoneNumberLabel: this.$ml.get("phoneNumberLabel"),
        example: this.$ml.get("examplePhone"),
      },
      ssoIsActive: false,
      errorAwaitNewRequest: false,
      userBugHunt: false,
    };
  },
  validations: {
    codeSms: { required, minLength: minLength(6) },
    code2fa: { required, minLength: minLength(6) },
  },

  mounted() {
    this.getUserType = this.$store.getters["getUserType"];
    this.getAccountMy(this.getUserType);
    this.$v.$reset();
    this.changeDados();

      if(this.getUserType === 'company'){
      this.ssoIsActive = this.$store.getters["getUser"].ssoSettings.enabled
    }
  },

  computed:{
    ssoEnabled() {
      let enabledSSO = false
       if(this.typeUser === 'company'){
        enabledSSO = this.$store.getters["getUser"]?.ssoSettings?.enabled;
       }
        return enabledSSO
    },
  },
  watch:{
    ssoEnabled() {
    this.ssoIsActive = this.ssoEnabled
  },
  },
  methods: {
    async getAccountMy(type){
      try {
       const {data} = await AccountService.getAccountMy(type);
       const {ssoSettings} = data
       this.ssoIsActive = ssoSettings.enabled
       
       if(data.email.split('@')[1] === 'bughunt.com.br'){
        this.userBugHunt = true;
       }
      } catch (error) {
        console.log(error.response);
      }
    },
    async sendCodeSms(action) {
      this.errorAwaitNewRequest = false;
      if(action === '2fa'){
        if (!this.phoneValidate) {
        this.$refs.refOnboarding.onboardingRegisterPhone();
        return;
       }
      }
    
      if (this.timeLeftSms > 0) return;

      const newCodeRequest = 300;
      this.timeLeftSms = newCodeRequest;

      const interval = setInterval(() => {
        if (this.timeLeftSms > 0) {
          this.timeLeftSms--;

          const minutes = Math.floor(this.timeLeftSms / 60);
          const seconds = this.timeLeftSms % 60;

          this.formattedTimeSMS = `${minutes}:${seconds
            .toString()
            .padStart(2, "0")}`;
        } else {
          clearInterval(interval);
          this.errorAwaitNewRequest = false;
        }
      }, 1000);

      try {
        const { status } = await accountService.getTokenSms();

        if (status === 200) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("sendToken"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (error) {
        console.log(error.response);
        if (
          error.response.data.message === "Telefone não cadastrado ou inativo"
        ) {
          Swal.fire({
            icon: "warning",
            title: this.$ml.get("phoneNotRegistered"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
        if (
          error.response.data.message ===
          "Aguarde 5 minutos para receber outro token"
        ) {
          this.errorAwaitNewRequest = true;
        }
      }
    },

    featureActivationAction(type) {
      this.actionType = type;
    },

    // execute the recaptcha widget
    executeRecaptcha(change) {
      this.function = change;

      this.getToken(this.tokenRecaptcha);
    },

    getToken(token) {
      switch (this.function) {
        case "sendSms":
          this.sendSms(token);
          break;
        case "activePhone":
          this.activePhone();
          break;
        case "active2fa":
          this.active2fa(token);
          break;
        case "show2fa":
          this.show2fa();
          break;
        case "inactivePhone":
          this.inactivePhone();
          break;

        default:
          break;
      }
    },

    async changeDados() {
      this.tokenRecaptcha = "";
      (this.phoneValidate = false),
        (this.authentication2Fa = false),
        (this.showInputPhone = false),
        (this.showInputSms = false),
        (this.showQrcode = false),
        (this.phone_hash = "");
      (this.desc = ""),
        AccountService.getAuthentication().then(
          (response) => {
            this.loading = false;
            if (response.data.phone_status == "active") {
              this.phoneValidate = true;
            }
            if (response.data.phone) {
              this.phone_hash = response.data.phone;
            }
            if (response.data.isTwoFactorAuthenticationEnabled) {
              this.authentication2Fa = true;
              this.showQrcode = true;
              this.recovery_keys = response.data.recovery_keys;
            }
            this.emailCodeRequired = response.data.email_code_required;

            this.$store.dispatch("setUser", {
              two_factor_auth_login:
                response.data?.isTwoFactorAuthenticationEnabled,
              email_code_required: response.data?.email_code_required,
              lockerPassword: response.data?.lockerPassword,
            });
          },
          () => {
            this.loading = false;
          },
        );
    },

    savePhone() {
      if (!this.phoneValidate) {
        setTimeout(() => {
          this.showInputPhone = true;
        }, 200);
      } else {
        this.executeRecaptcha("inactivePhone");
      }
    },

    updatePhoneNumber(number) {
      this.phone = {
        countryCode: number.countryCallingCode,
        number: number.nationalNumber,
        isValid: number.isValid,
      };
    },

    sendSms(tokenRecaptcha) {
      var self = this;

      if (!this.phone.isValid) {
        this.msgPhoneInvalid = true;
        return;
      }

      this.msgPhoneInvalid = false;
      this.loadingBtn = true;

      AccountService.postPhoneValidation({
        countryCode: this.phone.countryCode,
        number: this.phone.number,
        tokenRecaptcha: tokenRecaptcha,
      }).then(
        () => {
          this.loadingBtn = false;
          this.showInputSms = true;
          this.showInputPhone = false;

          Swal.fire({
            icon: "success",
            title: self.$ml.get("smsCodeSent"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });

          self.$refs.recaptcha.resetRecaptcha();
          self.tokenRecaptcha = "";
          this.codeSms = "";
        },
        () => {
          self.$refs.recaptcha.resetRecaptcha();
          self.tokenRecaptcha = "";
          self.loadingBtn = false;
        },
      );
    },

    activePhone() {
      var self = this;

      if (this.$v.codeSms.$invalid) {
        this.validError = true;
        return;
      }

      this.validError = false;
      this.loadingBtn = true;

      AccountService.postPhoneValidationCode({
        validate_code: this.codeSms,
        tokenRecaptcha: this.tokenRecaptcha,
      }).then(
        () => {
          this.loadingBtn = false;
          this.showInputSms = false;
          this.phoneValidate = true;
          Swal.fire({
            icon: "success",
            title: self.$ml.get("validatedPhone"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          this.$refs.recaptcha.resetRecaptcha();
          this.tokenRecaptcha = "";
          this.codeSms = "";
          this.changeDados();
        },
        () => {
          self.$refs.recaptchaPhone.resetRecaptcha();
          self.tokenRecaptcha = "";
          Swal.fire({
            icon: "warning",
            title: self.$ml.get("invalidCode"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          this.loadingBtn = false;
        },
      );
    },

    updateCodeInput(value) {
      this.disable2faCode = value;
    },
    updateCodeEmail(value) {
      this.codeEmail = value;
    },

    setDisablePhoneModalData() {
      this.modalData = {
        title: this.$ml.get("doYouWantToRemoveThePhone"),
        description: this.$ml.get("dataWillBeRemovedWithPhoneValidation"),
        type: "phone",
      };
    },

    inactivePhone() {
      this.setDisablePhoneModalData();

      this.showDisableAuthModal = true;
    },

    async disablePhoneValidation() {
      const sanitizedInputCode = String(this.disable2faCode.trim());

      try {
        this.$refs.disableAuthModal.credentialsError = false;
        await AccountService.deletePhone({
          password: sanitizedInputCode,
          tokenRecaptcha: this.tokenRecaptcha,
          email_token: Number(this.codeEmail),
        });

        this.showDisableAuthModal = false;

        Swal.fire({
          icon: "success",
          title: this.$ml.get("phoneSuccessfullyRemoved"),
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });

        await this.changeDados();
      } catch (error) {
        this.loading2fa = false;
        this.showDisableAuthModal = true;
        this.$refs.disableAuthModal.credentialsError = true;
        Swal.fire({
          icon: "warning",
          title: this.$ml.get("tryAgain"),
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    },

    setDisable2faModalData() {
      this.modalData = {
        title: this.$ml.get("doYouReallyWantToRemoveTwoFactor"),
        description: this.$ml.get("toDoThisYouNeedToEnterYourAppCode"),
        type: "2fa",
      };
    },
    async show2fa() {
      if (!this.phoneValidate) {
        this.$refs.refOnboarding.onboardingRegisterPhone();
        return;
      }

      if (this.authentication2Fa) {
        this.setDisable2faModalData();

        this.showDisableAuthModal = true;
      } else {
        this.loading2fa = true;
        this.qrCode = null;
        AccountService.get2fa().then(
          async (response) => {
            this.loading2fa = false;
            this.showQrcode = true;
            this.qrCode = response.data;
          },
          () => {
            this.loading2fa = false;
          },
        );
      }
    },

    async disable2faAuth() {
      const sanitizedInputCode = String(this.disable2faCode.trim());

      const code2fa = {
        code: sanitizedInputCode,
        recoveryKey: sanitizedInputCode,
        tokenRecaptcha: this.tokenRecaptcha,
        email_token: Number(this.codeEmail),
      };

      if (sanitizedInputCode.length > 6) {
        delete code2fa.code;
      } else {
        delete code2fa.recoveryKey;
      }

      try {
        this.$refs.disableAuthModal.credentialsError = false;
        await AccountService.put2faTurnoff({ ...code2fa });

        this.showDisableAuthModal = false;

        this.authentication2Fa = false;
        this.showQrcode = false;

        this.$store.dispatch("setUser", {
          two_factor_auth_login: false,
        });

        Swal.fire({
          icon: "success",
          title: `Two-factor authentication ${this.$ml.get("removed")}!`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        this.$refs.disableAuthModal.codeEmail = "";
        this.$refs.disableAuthModal.codeInput = "";
        this.codeSms = "";
      } catch (error) {
        this.loading2fa = false;
        this.showDisableAuthModal = true;
        this.$refs.disableAuthModal.credentialsError = true;

        if (
          error.response.data.message ===
          "O usuário não possui permissão para executar esta ação!"
        ) {        
          Swal.fire({
          icon: "warning",
          title: this.$ml.get("userDoesNotHavPermissionToPerform"),
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        return;
        }
        Swal.fire({
          icon: "warning",
          title: this.$ml.get("invalidCodeOrToken"),
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    },

    disableAuth(type) {
      const typesList = {
        phone: this.disablePhoneValidation,
        "2fa": this.disable2faAuth,
      };

      return typesList[type]();
    },
    active2fa(tokenRecaptcha) {
      var self = this;
      if (this.$v.code2fa.$invalid) {
        this.validError = true;
        return;
      }
      this.validError = false;
      this.loadingBtn = true;

      AccountService.put2faTurnOn({
        code: this.code2fa,
        tokenRecaptcha: tokenRecaptcha,
        sms_token: Number(this.codeSms),
      }).then(
        (response) => {
          this.code2fa = "";
          this.loadingBtn = false;
          this.authentication2Fa = true;
          this.codesRecovery = response.data;
          this.$store.dispatch("setUser", {
            two_factor_auth_login: true,
          });
          Swal.fire({
            icon: "success",
            title: `Two-factor authentication ${self.$ml.get("activated")}`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          this.$refs.recaptchaV2.resetRecaptcha();
          self.tokenRecaptcha = "";
        },
        () => {
          this.$refs.recaptchaV2.resetRecaptcha();
          self.tokenRecaptcha = "";
          Swal.fire({
            icon: "warning",
            title: self.$ml.get("invalidCode"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          this.loadingBtn = false;
        },
      );
    },

    generateKeys() {
      var self = this;

      this.loadingBtn = true;

      AccountService.postKeysGenerate().then(
        (response) => {
          this.loadingBtn = false;
          this.codesRecovery = response.data;

          Swal.fire({
            icon: "success",
            title: self.$ml.get("successfullyGeneratedKeys"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        },
        () => {
          this.loadingBtn = false;
        },
      );
    },

    downloadCSVData() {
      let csv = "Tokens - backup\n";

      this.codesRecovery.forEach((row) => {
        csv += row + "\n";
      });

      const anchor = document.createElement("a");
      anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = "tokens2fa.csv";
      anchor.click();
    },

    setRecaptchaToken(token) {
      this.tokenRecaptcha = token;
    },
  },
};
</script>

<style lang="scss">
.msgn {
  color: #730ba9;
}
.remove {
  background-color: rgba(241, 65, 65, 0.03);
}
.text-blue {
  color: #007bff;
}
.input-code {
  width: 90px;
}
.swal-2fa {
  width: 25em !important;
  padding: 0.5em !important;
  padding-top: 1em !important;
  border-radius: 5px;
  .swal2-input {
    height: 2.25em !important;
    padding: 0 0.55em !important;
    font-size: 0.9em !important;
  }
  .swal2-actions {
    margin: 0.2em auto 1em;
    padding: 0 1.6em;
  }
}
.vue-phone-number-input {
  max-width: 300px;
  input {
    height: 41px !important;
    margin-top: -2px;
  }
  .input-phone-number {
    margin: 0 10px;
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;
    .input-tel__input[data-v-e59be3b4]:not(.no-country-selector) {
      border-top-left-radius: 4px !important;
      border-bottom-left-radius: 4px !important;
    }
  }
}
</style>
